export default __webpack_public_path__ + "static/media/ThankYou_Header.5586ba7c.png";